import { render } from "./BuilderOptions.vue?vue&type=template&id=bd52387e"
import script from "./BuilderOptions.vue?vue&type=script&lang=js"
export * from "./BuilderOptions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__